/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import CommonQuickActionButtons from "../../../../components/_utils/CommonQuickActionButtons/index.jsx";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber/index.js";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import InternalScheduleTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalScheduleTxnDeclinePopup.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import InternalAccountDetailsPopup from "../../../../components/Accounts/InternalAccount/InternalAccountDetailsPopup/index.jsx";
import OwnerAccountDetailsPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountDetailsPopUp/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import { formatTimeSlot } from "../../../../components/ScheduleTransactions/helpers.js";
import ScheduleTxnOccurrencesPopup from "../../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup/index.jsx";
import InternalTransactionGridView from "../../../../components/Transactions/InternalTransaction/InternalTransactionGridView/index.jsx";
import ScheduleInternalTransactionViewAllPopup from "../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionViewallpopup/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { internalTransactionsViewAll } from "../../../../redux/features/transactions/internalTransactions/index.js";
import {
  scheduledInternalApprove,
  scheduledInternalDetailsById,
  scheduledInternalDiscard,
  scheduledInternalOccurrences,
  setScheduledInternalDetails,
  scheduledInternalAddLabel,
  scheduledInternalRemoveLabel,
} from "../../../../redux/features/transactions/scheduleInternalTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  SettingsStatisticsConfiguration,
  TimelineBarConfiguration,
} from "../../../../utils/configurationProvider.js";
import formatCurrency from "../../../../utils/CurrencyFormater.js";
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";
import TEXT from "../../../../utils/globalText.js";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import globalText from "../../../../utils/globalText.js";
import ScheduleInternalTransactionViewSchedules from "../ScheduleInternalTransactionViewSchedules/index.jsx";

/*                          CONSTANTS & PURE HELPERS                          */

const {
  lengthCheckZero: ZERO,
  lengthCheckOne: ONE,
  lengthCheckTwo: TWO,
  lengthCheckThree: THREE,
} = GlobalConfiguration;

const TAB_INDEX_BY_LABEL = {
  Details: ZERO,
  "Additional details": ONE,
  "Transaction created": TWO,
  "Assigned Labels": THREE,
};

const SOURCE_ACCOUNT_TXN_APPROVE_TYPE = "type bene_account_detail_modal";

const getFirstApiError = (response) =>
  response?.payload?.errors?.base?.[0]?.errors?.[0];

const getLabelErrorMessage = (res) => {
  const p = res?.payload;

  const unsuccessful =
    p?.ids?.unsuccessful_ids || p?.response?.data?.ids?.unsuccessful_ids;

  if (Array.isArray(unsuccessful) && unsuccessful.length) {
    const messages = unsuccessful
      .flatMap((item) =>
        Array.isArray(item?.errors) ? item.errors : [item?.errors],
      )
      .filter(Boolean);
    if (messages.length) return Array.from(new Set(messages)).join(", ");
  }

  if (typeof p === "string") return p;
  if (p?.message) return p.message;
  if (p?.errors?.base?.[0]) {
    const base = p.errors.base[0];
    return typeof base === "string" ? base : base?.errors?.[0] || base?.message;
  }

  const e = res?.error;
  if (e?.message && e.message !== "Rejected") return e.message;
  return "Something went wrong";
};

const showLabelToast = (text, ok) => {
  toast.dismiss();
  CommonToast({
    text,
    icon: ok
      ? ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE
      : ICONS?.ERROR_WITH_WHITE_CIRCLE,
    variant: ok ? "var(--success)" : "var(--error)",
  });
};

/** "5 Jan, 2026" (invalid input intentionally renders the same as before). */
const formatDate = (value) => {
  const dateObj = new Date(value);
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const month = dateObj.toLocaleString("default", { month: "short" });
  return `${day} ${month}, ${year}`;
};

// NOTE: kept exactly as before (renders "NaN" when frequency is missing).
const formatFrequency = (frequency) =>
  frequency?.charAt(0).toUpperCase() + frequency?.slice(1);

const formatSlot = (slot) =>
  formatTimeSlot(slot ?? " - ")
    ?.replace(/\bAM\b/g, "am")
    ?.replace(/\bPM\b/g, "pm");

const isAttachmentItem = (item) =>
  (item.data_type.toLowerCase() === "hyperlink" ||
    item.data_type === "File" ||
    item.data_type === "upload") &&
  "value" in item;

/** Whether the attachments card should be shown at all. */
const hasVisibleAttachments = (attachments) =>
  attachments.some((obj) => {
    if (obj.data_type === "hyperlink") return Boolean(obj.value);
    const file = obj.value;
    return Boolean(file && file.metadata && file.file_url);
  });

const toAdditionalDetailEntry = (item) => {
  switch (item.data_type) {
    case "from_year_to_year": {
      const from = item.value?.from;
      const to = item.value?.to;
      return {
        heading: item.name,
        content: from && to ? `${from} - ${to}` : "Not given",
        type: "text",
      };
    }
    case "date_range": {
      const start = item.value?.start_date;
      const end = item.value?.end_date;
      return {
        heading: item.name,
        content: start && end ? `${start} - ${end}` : "Not given",
        type: "text",
      };
    }
    case "multi_select_list":
      return {
        heading: item.name,
        content: item.value?.length ? item.value.join(", ") : "Not given",
        type: "text",
      };
    case "toggle":
      return {
        heading: item.name,
        content: item.value ? "Yes" : "No",
        type: "text",
      };
    case "hyperlink":
    case "upload":
      return null;
    default:
      return {
        heading: item.name,
        content: item.value ?? "Not given",
        type: "text",
      };
  }
};

const toAttachmentEntry = (obj, onImageClick) => {
  switch (obj.data_type) {
    case "hyperlink": {
      if (!obj.value) return null;
      return {
        heading: "URL",
        content: obj.value || "Not given",
        type: "link",
      };
    }
    case "upload":
    case "file": {
      const file = obj.value;
      if (!file || !file.metadata || !file.file_url) return null;

      const mimeType = file?.metadata?.mime_type || "application/octet-stream";
      const baseContent = {
        size: file.metadata.size,
        fileName: file.metadata.filename,
        mimeType: file.metadata.mime_type,
        url: file.file_url,
      };

      if (mimeType.startsWith("image/")) {
        return {
          heading: "Image",
          type: "image",
          content: {
            ...baseContent,
            onUrlClick: () =>
              onImageClick({
                name: file.metadata.filename || "Unknown file",
                url: file.file_url,
              }),
          },
        };
      }
      return {
        heading: "File",
        type: "file",
        content: {
          ...baseContent,
          onUrlClick: () => {
            window.open(file.file_url, "_blank")?.focus();
          },
        },
      };
    }
    default:
      return null;
  }
};

/*                           SMALL PRESENTATIONAL PARTS                       */

const AccountLink = ({ accountNumber, subtitle, disabled, onClick }) => (
  <TitleSubtitlePair
    isDisabled={disabled}
    alignRight={false}
    title={formatAccountNumber(accountNumber ?? "")}
    titleColor={"text-primary"}
    subtitle={subtitle}
    onClick={onClick}
    info={false}
    showArrow={true}
    hoverOption={"white"}
    isBold={false}
    variant={"md"}
  />
);

const IfscPair = ({ title }) => (
  <TitleSubtitlePair
    isDisabled={false}
    alignRight={false}
    title={title}
    titleColor={"text-primary"}
    subtitle={TEXT?.IFSC_CODE}
    info={false}
    showArrow={false}
    isBold={false}
    variant={"md"}
  />
);

/**
 * NOTE: the double wrapper below is intentional (kept from the original) so the
 * backdrop looks exactly the same as before.
 */
const HistoryPopup = ({ title, onClose, contentProps }) => (
  <div className="fixed top-top-base left-left-base w-width-full h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-light-opacity">
    <ScheduleInternalTransactionViewAllPopup
      onClose={onClose}
      headerTitle={title}
      headerSubtitle="All scheduled transaction related to internal are listed below."
      popupProps={{ isscrollRequired: true }}
      contentProps={contentProps}
    />
  </div>
);

const ScheduleTimelinePopup = ({
  logsData,
  onClose,
  handleApprovalClick,
  showApprovalTimeline,
  openApprovalTimeline,
  handleApprovalTimeline,
  setOpenApprovalTimeline,
}) => (
  <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-light-opacity">
    <LargePopupRedirect
      headerTitle="Schedule timeline"
      headerFontWeight="semibold"
      headerFontColor="text-primary"
      headertextSize="font-md"
      closeiconenabledBgColor="var(--primary-nav)"
      closeiconisLoading={false}
      closeiconhandleFunction={onClose}
      closeicon={ICONS?.CLOSE}
      closeiconhoverOption="white"
      closeiconbtnType={"button"}
      closeiconisDisabled={false}
      closeicondisabledBgColor={""}
      closeiconbuttonRef={null}
      closeicontitle={"Close"}
      btnType={"button"}
      handleFunction={() => {}}
      enabledBgColor={"var(--positive-act)"}
      hoverOption={"dark"}
      outLineColor={""}
      enabledTextColor={"var(--text-primary)"}
      fullWidthRequired={false}
      isDisabled={false}
      disabledTextColor={""}
      disabledBgColor={""}
      isLoading={false}
      buttonRef={null}
      inActiveVariantNeeded={false}
      isLoaderNeeded={false}
      isscrollRequired={true}
    >
      <TimelinePopupContent
        logsData={logsData}
        handleApprovalClick={handleApprovalClick}
        showDistributionRightIcon={false}
        showApprovalLeftIcon={false}
        showApprovalTimeline={showApprovalTimeline}
        openApprovalTimeline={openApprovalTimeline}
        handleApprovalTimeline={handleApprovalTimeline}
        setOpenApprovalTimeline={setOpenApprovalTimeline}
        cardType={"single"}
        popUpMode={true}
      />
    </LargePopupRedirect>
  </div>
);

/* ------------------------------ summary (web) ----------------------------- */

const ScheduleSummaryDesktop = ({
  data,
  isPopup,
  isConfidential,
  isDeleted,
  ownerDisabled,
  internalDisabled,
  hasModService,
  onOpenConfidential,
  onOpenHistory,
  onOwnerClick,
  onInternalClick,
  onDiscardClick,
}) => (
  <div className="hidden bg-primary-nav Qsmd:flex flex-row justify-center relative Qsmd:px-padding-md">
    <div
      className={`Qlg:max-w-tab-width-normal Qlg:w-std-width Qsmd:w-width-full relative ml-margin-md Qsmd:ml-margin-base`}
    >
      <div className="h-auto flex flex-row justify-center items-stretch">
        <div className=" w-width-full flex flex-row justify-start items-center py-padding-md Qsmd:w-width-md">
          <TitleSubtitlePair
            title={data?.scheduled_name ?? "N/A"}
            titleColor="text-primary"
            subtitle={TEXT?.SCHEDULE_NAME}
            info={false}
            alignRight={false}
            hoverOption="white"
            isBold={false}
            variant="md"
          />
        </div>

        <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md"></div>
        <div className="w-width-full flex flex-row justify-between items-center Qsmd:w-width-lg">
          <div>
            <TitleSubtitlePair
              title={`INR ${formatCurrency(data?.amount ?? "")}`}
              titleColor="settled"
              subtitle="Amount"
              info={false}
              alignRight={false}
              hoverOption="white"
              isBold={true}
              variant="md"
            />
          </div>
          <div className="hidden Qsmd:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base h-height-full">
            <div className="Qsmd:flex flex-row overflow-hidden justify-end w-auto h-height-full">
              {isConfidential ? (
                <TopNavSmallButton
                  btnText={
                    <>
                      Confidential <br />
                      transaction
                    </>
                  }
                  btnType="button"
                  icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                  handleFunction={onOpenConfidential}
                  isDisabled={isPopup}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-nav-act)"
                  disabledBgColor="var(--primary-nav-act)"
                  disabledTextColor="var(--text-primary)"
                  hoverOption="white"
                  fullWidthRequired={false}
                />
              ) : (
                <div className="w-positive-negative-btn-width px-padding-xl ml-margin-lg py-padding-md box-border hidden" />
              )}

              {isConfidential && (
                <div className="border-r border-solid border-primary-bg my-margin-sm" />
              )}

              <TopNavSmallButton
                btnText={
                  <>
                    Schedule <br /> history
                  </>
                }
                btnType="button"
                icon={ICONS?.TRANSACTION_HISTORY}
                handleFunction={onOpenHistory}
                isDisabled={isPopup}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav-act)"
                disabledBgColor="var(--primary-nav-act)"
                disabledTextColor="var(--text-primary)"
                hoverOption="white"
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="border-primary-bg"></hr>
      <div className="flex flex-row justify-center relative">
        <div className="w-width-full flex flex-col items-center justify-around Qsmd:pt-padding-sm gap-gap-md Qsmd:w-width-md">
          <div className="Qsmd:translate-x-[-0.5rem] flex flex-row items-center justify-between w-width-full Qsmd:pt-padding-sm">
            <div className={ownerDisabled ? " pl-padding-base " : ""}>
              <AccountLink
                accountNumber={data?.owner_account_bank_acc_no}
                subtitle={TEXT?.SOURCE_ACCOUNT}
                disabled={ownerDisabled}
                onClick={onOwnerClick}
              />
            </div>
            <CommonBankLogo
              ifsc={data?.owner_account_ifsc_code ?? ""}
              variant="big"
              type="pill"
            />
          </div>
          <div className="flex flex-row justify-between items-center w-width-full h-positive-negative-btn-height Qlg:pt-padding-base pt-padding-sm Qsmd:px-padding-sm Qsmd:pl-padding-base">
            <IfscPair title={data?.owner_account_ifsc_code ?? ""} />

            <TitleSubtitlePair
              textAlign="right"
              alignRight={true}
              title={(data?.payment_method ?? "N/A") || "N/A"}
              subtitle={TEXT?.PAYMENT_METHOD}
              variant="md"
            />
          </div>
        </div>
        <div className=" my-auto h-full flex flex-shrink-0 flex-col justify-center items-center">
          <div className=" absolute border-l border-l-primary-bg h-height-vertical"></div>
          <div className="arrow-icon bg-primary-nav px-padding-xs py-padding-sm relative">
            <img
              src={ICONS?.ARROW_RIGHT_BLUE_WHITE}
              alt="CircledWhiteArrow"
              className="w-icon-md h-icon-md"
            />
          </div>
        </div>

        <div
          className={`w-width-full flex flex-col Qsmd:w-width-lg ${!isDeleted ? "items-start gap-y-gap-md" : "justify-around"}`}
        >
          <div className="flex flex-row items-center justify-between w-width-full gap-gap-md">
            <div
              className={`flex items-center justify-between mr-margin-md Qsmd:mr-margin-base w-full ${isDeleted ? "Qsmd:pt-padding-base" : "Qsmd:pt-padding-sm"}`}
            >
              <div>
                <AccountLink
                  accountNumber={data?.internal_account_bank_acc_no}
                  subtitle={"Destination account"}
                  disabled={internalDisabled}
                  onClick={onInternalClick}
                />
              </div>

              <CommonBankLogo
                ifsc={data?.internal_account_ifsc_code ?? "Not available"}
                variant="big"
                type="pill"
              />
            </div>

            {!isDeleted ? (
              <div>
                <TopNavSmallButton
                  btnText={
                    <>
                      Discard <br /> Schedule
                    </>
                  }
                  btnType="button"
                  icon={ICONS?.DISCARD_WITH_WHITE_CIRCLE}
                  handleFunction={onDiscardClick}
                  isDisabled={isPopup || !hasModService}
                  enabledTextColor="var(--text-primary)"
                  enabledBgColor="var(--primary-nav-act)"
                  disabledBgColor="var(--primary-nav-act)"
                  disabledTextColor="var(--text-primary)"
                  hoverOption="white"
                />
              </div>
            ) : (
              <div className="min-w-[90px] min-h-[90px]"></div>
            )}
          </div>
          <div
            className={`flex flex-row gap-x-gap-md w-width-lg pl-padding-sm items-center ${!isDeleted ? "justify-between" : "items-start pt-padding-sm"}`}
          >
            <IfscPair
              title={(data?.internal_account_ifsc_code ?? "") || "N/A"}
            />
            <div className="w-topnav-small-btn-width h-positive-negative-btn-height"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* ----------------------------- summary (mobile) --------------------------- */

const ScheduleSummaryMobile = ({
  data,
  ownerDisabled,
  internalDisabled,
  onOwnerClick,
  onInternalClick,
}) => (
  <div className="flex flex-col Qsmd:hidden w-width-full bg-primary-nav">
    <div className="sched-name-mobile flex flex-col p-padding-md Qsmd:px-padding-md px-padding-md">
      <TitleSubtitlePair
        title={data?.scheduled_name ?? "N/A"}
        titleColor="text-primary"
        subtitle={TEXT?.SCHEDULE_NAME}
        info={false}
        alignRight={false}
        hoverOption="white"
        isBold={false}
        variant="md"
      />
    </div>
    <hr className="border-primary-bg mx-margin-md Qlg:mx-margin-base"></hr>
    <div className="flex flex-col p-padding-md Qsmd:px-padding-md px-padding-md">
      <TitleSubtitlePair
        title={`INR ${formatCurrency(data?.amount ?? "N/A")}`}
        titleColor="settled"
        subtitle="Amount"
        info={false}
        alignRight={false}
        hoverOption="white"
        isBold={true}
        variant="md"
      />
    </div>
    <hr className="border-primary-bg mx-margin-md Qlg:mx-margin-base"></hr>
    <div className="flex flex-col Qlg:pl-padding-sm py-padding-sm">
      <div className="flex flex-row items-center justify-between ml-margin-base Qlg:ml-0 px-padding-sm   ">
        <AccountLink
          accountNumber={data?.owner_account_bank_acc_no}
          subtitle={TEXT?.SOURCE_ACCOUNT}
          disabled={ownerDisabled}
          onClick={onOwnerClick}
        />
        <div className="bg-text-primary rounded-full mr-margin-md p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s">
          <CommonBankLogo
            ifsc={data?.owner_account_ifsc_code ?? ""}
            variant="big"
          />
        </div>
      </div>
      <div className="flex flex-row gap-gap-md justify-around items-center Qlg:pr-padding-md mx-margin-md Qlg:mx-margin-base ">
        <div className="border-b border-solid border-primary-bg w-width-full"></div>
        <img
          src={ICONS?.ARROW_DOWN_BLUE_WHITE}
          alt="arrowDownBlueWhite"
          className="w-icon-md"
        />
        <div className="border-b border-solid border-primary-bg w-width-full"></div>
      </div>
      <div className="flex flex-row items-center justify-between Qlg:ml-margin-base px-padding-sm">
        <AccountLink
          accountNumber={data?.internal_account_bank_acc_no}
          subtitle={"Destination account"}
          disabled={internalDisabled}
          onClick={onInternalClick}
        />
        <div className="bg-text-primary rounded-full p-padding-sm mr-margin-md flex flex-row justify-center items-center px-padding-sm py-padding-button-s">
          <CommonBankLogo
            ifsc={data?.internal_account_ifsc_code ?? ""}
            variant="big"
          />
        </div>
      </div>
    </div>
    <hr className="border-primary-bg mx-margin-md Qlg:mx-margin-base"></hr>
    <div className="flex flex-col gap-gap-xs p-padding-md Qsmd:px-padding-md px-padding-md">
      <TitleSubtitlePair
        alignRight={false}
        title={(data?.payment_method ?? "N/A") || "N/A"}
        subtitle={TEXT?.PAYMENT_METHOD}
        variant="md"
      />
    </div>
  </div>
);

/* --------------------------------- tabs ---------------------------------- */

const TransferDetailsTab = ({
  transactions,
  data,
  tabIndex,
  animationClass,
  isPopup,
  hasOccurrenceService,
  onOccurrencesClick,
}) =>
  transactions.map((account) => {
    const originItemList = [
      {
        heading: "Created by",
        content: `${account?.logs?.[0]?.first_name ?? ""} ${account?.logs?.[0]?.last_name ?? ""}`,
        type: "text",
      },
      {
        heading: "Created on",
        content: formatDateViewAll(account?.created_on, true, true),
        type: "text",
      },
    ];

    if (account?.created_via) {
      originItemList.push({
        heading: "Created via",
        content: account.created_via,
        type: "text",
      });
    }

    return (
      // key includes tabIndex so the slide animation restarts on tab change
      <div key={`${tabIndex}-${account.txn_id}`} className={animationClass}>
        <div
          className={`flex flex-col lg:flex-row my-margin-md mx-auto  lg:px-padding-base gap-gap-md max-w-screen-Qlg `}
        >
          <CommonDetailCard
            variant="third"
            numCols={ONE}
            cardTitle="Transfer Details"
            entries={[
              {
                heading: "Frequency",
                content: formatFrequency(data?.frequency),
                type: "text",
              },
              {
                heading: "Schedule start date",
                content: formatDate(
                  data?.transaction_start_date || "Not available",
                ),
                type: "text",
              },
              {
                heading: "Schedule end date",
                content: formatDate(
                  data?.transaction_end_date || "Not available",
                ),
                type: "text",
              },
              {
                heading: "Time slot",
                content: formatSlot(data?.slot),
                type: "text",
              },
              {
                heading: "Occurrences",
                content: Number(data?.occurrences || 0),
                type: "text",
                onClick: onOccurrencesClick,
                isDisabled: isPopup || !hasOccurrenceService,
              },
            ]}
          />

          <CommonDetailCard
            cardTitle={TEXT?.ORIGIN_DETAILS}
            variant="third"
            numCols={ONE}
            entries={originItemList}
          />
        </div>
      </div>
    );
  });

const AdditionalDetailsTab = ({
  transactions,
  tabIndex,
  animationClass,
  onImageClick,
}) => {
  const allAdditionalData = transactions.flatMap(
    (txn) => txn.additional_data?.data ?? [],
  );

  if (!allAdditionalData.length) {
    return (
      <div key={tabIndex} className={animationClass}>
        <div className="w-details-card-md flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md mt-margin-md">
          <div className="text-text-primary text-font-sm font-semibold">
            {globalText?.CATEGORY_SPECIFIC_DETAILS}
          </div>
          <p className="text-text-secondary text-font-xs font-normal">
            Additional details are not supported for the selected category.
          </p>
        </div>
      </div>
    );
  }

  const attachments = allAdditionalData.filter(isAttachmentItem);
  const attachmentEntries = attachments
    .map((obj) => toAttachmentEntry(obj, onImageClick))
    .filter(Boolean);

  return (
    <div key={tabIndex} className={animationClass}>
      <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md  lg:px-padding-base max-w-screen-Qlg mx-auto">
        <CommonDetailCard
          cardTitle={globalText?.CATEGORY_SPECIFIC_DETAILS}
          variant="third"
          numCols={
            allAdditionalData.length === TimelineBarConfiguration?.largewidth
              ? TimelineBarConfiguration?.largewidth
              : SettingsStatisticsConfiguration?.strokeWidthForLineGraph
          }
          entries={allAdditionalData
            .map(toAdditionalDetailEntry)
            .filter(Boolean)}
        />
        {hasVisibleAttachments(attachments) && (
          <CommonDetailCard
            cardTitle={TEXT?.ATTACHMENTS}
            variant="third"
            numCols={ONE}
            entries={attachmentEntries}
          />
        )}
      </div>
    </div>
  );
};

const TransactionsCreatedTab = ({
  tabIndex,
  animationClass,
  transactions,
  filterRef,
}) => (
  <div
    key={tabIndex}
    className={`${animationClass} flex flex-col Qmd:flex-row gap-y-gap-md gap-x-gap-sm flex-wrap  `}
  >
    <InternalTransactionGridView
      data={transactions}
      typepop="schedDetailViewAll"
      filterRef={filterRef}
    />
  </div>
);

const LabelsTab = ({
  tabIndex,
  animationClass,
  labelDetails,
  iconIsDisabled,
  onEdit,
  isPopup,
  setLabelName,
  actionRestricted,
  setOpenLabelSearchPopup,
}) => (
  <div key={tabIndex} className={animationClass}>
    <div className="my-margin-md mx-auto max-w-screen-Qlg lg:px-padding-base">
      <CommonContainerCard
        header="Labels"
        iconIsDisabled={iconIsDisabled}
        subheader={TEXT?.LABELS_USAGE_NOTE}
        icon={ICONS?.EDIT}
        handleFunction={onEdit}
      >
        <div className="flex flex-wrap w-full gap-gap-sm overflow-x-auto">
          {Array.isArray(labelDetails) && labelDetails.length ? (
            labelDetails.map((item, idx) => (
              <Chips
                key={idx}
                txtChip={item}
                enabledBgColor="var(--primary-nav)"
                disableIcon={true}
                hoverOptionBtn="white"
                handleFunctionBtn={() => {
                  if (isPopup) {
                    actionRestricted();
                    return;
                  }
                  setLabelName(item);
                  setOpenLabelSearchPopup(true);
                }}

                enabledTextColor="var(--text-primary)"
              />
            ))
          ) : (
            <p className="text-font-sm text-text-primary">
              No labels assigned.
            </p>
          )}
        </div>
      </CommonContainerCard>
    </div>
  </div>
);

/*                                 COMPONENT                                  */

const ScheduleInternalTransactionDetails = ({
  isPopup,
  txn_id,
  detailSelected,
  closeScheduleInternalTxnModal,
  typeMulti,
  type,
  flow,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const paramId = useParams().id;
  const id = txn_id ?? paramId;
  const services = useSelector((state) => state.refreshToken.services);
  const {
    scheduledInternalApproveLoading,
    scheduledInternalDetailsData,
    scheduledInternalDiscardLoading,
    scheduledInternalRejectError,
  } = useSelector((s) => s.scheduleInternalTransactions);

  const cardRefs = useRef({});
  const scrollContainerRef = useRef(null);

  const dropdownOptions = PaginationConfiguration?.paginationOptions;
  const hasModService = services?.includes("IAScheduledTxn");
  const hasOccurrenceService = services?.includes("IOScheduledTxn");

  /* -------------------------------- state -------------------------------- */
  // schedule data
  const [scheduleUpdatedData, setScheduleUpdatedData] = useState(null);
  const [scheduleDetailsData, setScheduleDetailsData] = useState({});
  const [scheduleId, setScheduleId] = useState("");
  const [scheduleInternalTxnList, setScheduleInternalTxnList] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [scheduleOccurrenceDates, setScheduleOccurrenceDates] = useState([]);
  const [labelName, setLabelName] = useState("");
  const [openLabelSearchPopup, setOpenLabelSearchPopup] = useState(false);
  // loading / binding
  const [isloading, setIsLoading] = useState(true);

  // schedule flags
  const [scheduleDeleted, setScheduleDeleted] = useState(false);
  const [isScheduleRejected, setIsScheduleRejected] = useState(false);
  const [isScheduleApproved, setIsScheduleApproved] = useState(false);
  const [isScheduleConfidential, setIsScheduleConfidential] = useState(false);
  const [scheduleInternalApproved, setScheduleInternalApproved] =
    useState(true);

  // approve / reject
  const [btnClicked, setbtnClicked] = useState({});
  const [scheduleApproveFailed, setScheduleApproveFailed] = useState(false);
  const [scheduleApproveFailedMessage, setScheduleApproveFailedMessage] =
    useState("");
  const [, setIsSceduleApproveLoader] = useState(false);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [, setIsOpen] = useState(false);

  // popups
  const [openTxnHistory, setOpenTxnHistory] = useState(false);
  const [openConfHistory, setOpenConfHistory] = useState(false);
  const [showPromptModal, setShowPromptModal] = useState(false);
  const [showRejectPrompt, setShowRejectPrompt] = useState(false);
  const [showOccurrencesModal, setShowOccurrencesModal] = useState(false);
  const [ownerDetailpop, setOwnerDetailpop] = useState(false);
  const [isInternalAccountDetailsOpen, setIsInternalAccountDetailsOpen] =
    useState(false);
  const [selectedImage, setSelectedImage] = useState({});
  const [openImageUrl, setOpenImageUrl] = useState(false);

  // timeline popup
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(scheduledInternalDetailsData?.[0]?.logs?.length || 0).fill(false),
  );

  // tabs
  const [selectedDetail, setSelectedDetail] = useState(
    detailSelected === "Additional details" ? "Additional details" : "Details",
  );
  const [tabIndex, setTabIndex] = useState(
    TAB_INDEX_BY_LABEL[selectedDetail] ?? ZERO,
  );
  const [prevIndex, setPrevIndex] = useState(ZERO);
  const [animationClass, setAnimationClass] = useState("");

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  // labels
  const [labels, setLabels] = useState([]);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const labelActionDispatchedRef = useRef(false);

  /* ------------------------------- derived -------------------------------- */
  const labelTxnIds = [id].filter(Boolean);
  const labelDetails =
    scheduledInternalDetailsData?.transaction?.[0]?.labels ?? [];
  const labelsEditDisabled =
    !(services?.includes("ALabel") && services?.includes("RLabel")) || isPopup;

  const ownerDisabled = isPopup || !services?.includes("VAccount");
  const internalDisabled =
    isPopup ||
    !(services?.includes("IVAccount") || services?.includes("Admin"));
  const showStatusBar = !(isScheduleApproved || scheduleDeleted);
  const hasCreatedTransactions = scheduleInternalTxnList?.length > ZERO;
  const hasTransactionRows = transactionData?.payload?.transactions?.length > 0;

  /* ------------------------------ small helpers --------------------------- */
  const goFeatureNotAssigned = (unavailableService) =>
    navigate("/feature_not_assigned", { state: { unavailableService } });

  const setBtnClickedFor = (value) =>
    setbtnClicked((prev) => ({ ...prev, [scheduleId]: value }));

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${txn_id}`,
    });
  };

  // run function only when not popup (shows restricted popup otherwise)
  const runIfNotPopup =
    (fn) =>
    (...args) => {
      if (isPopup) {
        actionRestricted();
        return;
      }
      if (typeof fn === "function") return fn(...args);
    };

  const safeSetShowPromptModal = () => {
    if (isPopup) {
      actionRestricted();
      return;
    }
    setShowPromptModal(true);
  };

  const removeDataFromStorage = () => {
    const storedData = JSON.parse(
      sessionStorage.getItem("intSelectedScheduleCard"),
    );

    if (storedData) {
      const updatedTransactions = storedData?.[0]?.selectedDetails.filter(
        (transaction) => transaction.txn_id !== scheduleId,
      );
      const updatedTransactionsId = storedData?.[0]?.selectedIds.filter(
        (transaction) => transaction !== scheduleId,
      );

      sessionStorage.setItem(
        "intSelectedScheduleCard",
        JSON.stringify([
          {
            selectedDetails: updatedTransactions,
            selectedIds: updatedTransactionsId,
          },
        ]),
      );
    }
  };

  /* ------------------------------- handlers ------------------------------- */
  const handleInternalAccountDetailsClose = () => {
    setIsInternalAccountDetailsOpen(false);
    dispatch(scheduledInternalDetailsById({ id }));
  };

  const handleScheduleDiscard = async () => {
    try {
      UniversalRefreshToast("Discarding schedule");

      const result = await dispatch(
        scheduledInternalDiscard({ id: scheduleId }),
      );

      if (result?.payload?.status) {
        toast.dismiss();

        const data = structuredClone(result?.payload);
        data.transaction = result?.payload?.transactions;
        delete data?.transactions;

        dispatch(setScheduledInternalDetails(data));

        CommonToast({
          text: "Schedule discarded successfully.",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
      }
      setShowPromptModal(false);
    } catch (errorMessage) {
      setShowPromptModal(false);
    }
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
  };

  const handlePagination = (page) => setCurrentPage(page);

  const openTransactionHistory = () => setOpenTxnHistory(true);
  const openConfidentialHistory = () => setOpenConfHistory(true);

  const handleShowOccurrences = async () => {
    const response = await dispatch(
      scheduledInternalOccurrences({
        frequency: scheduleDetailsData?.frequency ?? "",
        transaction_start_date:
          scheduleDetailsData?.transaction_start_date || "Not available",
        transaction_end_date:
          scheduleDetailsData?.transaction_end_date || "Not available",
        services,
        navigate,
      }),
    );
    setScheduleOccurrenceDates(response?.payload?.dates ?? []);
    setShowOccurrencesModal(true);
  };

  const handleOccurrencesClick = () => {
    if (isPopup) {
      actionRestricted();
    } else if (hasOccurrenceService) {
      handleShowOccurrences();
    } else {
      goFeatureNotAssigned("IOScheduledTxn");
    }
  };

  const handleApprove = async () => {
    setBtnClickedFor("Approve");
    setIsSceduleApproveLoader(true);
    UniversalRefreshToast("Approving schedule");

    let response;
    if (type === SOURCE_ACCOUNT_TXN_APPROVE_TYPE) {
      response = await dispatch(scheduledInternalApprove({ id: txn_id }));
    } else {
      response = await dispatch(scheduledInternalApprove({ id: scheduleId }));

      if (response?.payload?.status ?? false) {
        if (typeMulti === "MultiApproval") {
          removeDataFromStorage();
        }
        setShowRejectPrompt(false);
      } else {
        setBtnClickedFor("none");
        setScheduleApproveFailed(true);
        setShowRejectPrompt(false);
        setScheduleApproveFailedMessage(
          getFirstApiError(response) ??
            "Something went wrong while rejecting transaction",
        );
      }
      dispatch(scheduledInternalDetailsById({ id }));
    }

    if (response?.payload?.status) {
      toast.dismiss();
      const data = structuredClone(response?.payload);
      data.transaction = response?.payload?.transactions;
      delete data?.transactions;

      dispatch(setScheduledInternalDetails(data));

      setIsSceduleApproveLoader(false);
      if (typeMulti === "MultiApproval") {
        removeDataFromStorage();
      }

      setTimeout(() => {
        CommonToast({
          text: "Schedule approved successfully.",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
      }, IntervalConfiguration?.intervalLarge);
    } else {
      setBtnClickedFor("none");
      setScheduleApproveFailedMessage(
        getFirstApiError(response) ??
          "Something went wrong while approving transaction",
      );

      if (
        getFirstApiError(response) ===
          "Cannot approve. Transaction was auto-rejected as its start date or slot time has already passed." &&
        typeMulti === "MultiApproval"
      ) {
        removeDataFromStorage();
      }
      setScheduleApproveFailed(true);
      setTimeout(() => {
        CommonToast({
          text: getFirstApiError(response),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      }, IntervalConfiguration?.intervalLarge);
    }

    if (
      (typeMulti === "MultiApproval" ||
        typeMulti === "MultiApprovalSelect" ||
        flow === "Schedule_txn_detail_modal") &&
      isPopup
    ) {
      setTimeout(() => {
        closeScheduleInternalTxnModal();
        window.location.reload();
      }, 3000);
    }
  };

  // shared by web + mobile timeline status bars
  const handleRejectClick = () => {
    if (hasModService) {
      setBtnClickedFor("Reject");
      setShowRejectPrompt(true);
    } else {
      goFeatureNotAssigned("IAScheduledTxn");
    }
  };

  const handleApproveClick = () => {
    if (hasModService) {
      setBtnClickedFor("Approve");
      handleApprove();
    } else {
      goFeatureNotAssigned("IAScheduledTxn");
    }
  };

  const handleApprovalPendingClick = () => {
    if (services?.includes("IAAccount")) {
      setIsInternalAccountDetailsOpen(true);
    } else {
      goFeatureNotAssigned("IAAccount");
    }
  };
  const handleDiscardClick = () => {
    if (hasModService) {
      safeSetShowPromptModal();
    } else {
      goFeatureNotAssigned("IAScheduledTxn");
    }
  };

  // shared by web + mobile account links
  const handleOwnerClick = () => {
    if (isPopup) {
      actionRestricted();
      return;
    }
    if (!services?.includes("VAccount")) {
      goFeatureNotAssigned("VAccount");
      return;
    }
    setOwnerDetailpop(true);
  };

  const handleInternalAccountClick = () => {
    if (isPopup) {
      actionRestricted();
      return;
    }

    if (services?.includes("IVAccount") || services?.includes("Admin")) {
      setIsInternalAccountDetailsOpen(true);
    } else {
      goFeatureNotAssigned("IVAccount, Admin");
    }
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const handleTimelinePopup = () => {
    if (isPopup) {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
    }
  };

  const closeTimelinePopup = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };

  const handleImageClick = (image) => {
    setOpenImageUrl(true);
    setSelectedImage(image);
  };

  const selectTab = (label, index) => () => {
    setSelectedDetail(label);
    setTabIndex(index);
  };

  const runLabelAction = async (thunk, labelsPayload, successText) => {
    setLabelPopupLoading(true);
    const res = await dispatch(
      thunk({ record_ids: labelTxnIds, labels: labelsPayload }),
    );
    const ok = thunk.fulfilled.match(res);

    if (ok) {
      showLabelToast(successText, true);
      dispatch(scheduledInternalDetailsById({ id }));
      labelActionDispatchedRef.current = true;
      setSelectedDetail("Assigned Labels");
      setTabIndex(THREE);
    } else {
      showLabelToast(getLabelErrorMessage(res), false);
    }

    setLabelPopupLoading(false);
    return ok;
  };

  const handleAssignLabelsProp = (labelsToAssign) =>
    runLabelAction(
      scheduledInternalAddLabel,
      labelsToAssign,
      "Labels assigned successfully.",
    );

  const handleUnassignLabelsProp = (labelsToUnassign) =>
    runLabelAction(
      scheduledInternalRemoveLabel,
      labelsToUnassign,
      "Labels unassigned successfully.",
    );

  const handleLabelClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    setTabIndex(THREE);
  };

  const handleEditLabels = (e) => {
    e?.stopPropagation?.();
    if (!(services?.includes("ALabel") && services?.includes("RLabel"))) {
      goFeatureNotAssigned("ALabel,RLabel");
      return;
    }
    if (isPopup) {
      actionRestricted();
      return;
    }
    setShowLabelsPopup(true);
  };

  /* -------------------------------- effects ------------------------------- */

  useEffect(() => {
    setLabels(scheduledInternalDetailsData?.summary?.available_labels);
  }, [scheduledInternalDetailsData]);

  useEffect(() => {
    if (!scheduledInternalDetailsData) return;

    setScheduleUpdatedData((prev) =>
      JSON.stringify(prev) === JSON.stringify(scheduledInternalDetailsData)
        ? prev
        : scheduledInternalDetailsData,
    );
  }, [scheduledInternalDetailsData]);

  // fetch details
  useEffect(() => {
    try {
      dispatch(disableSwitcher());
      if (services) {
        dispatch(scheduledInternalDetailsById({ id }));
      }
    } catch (error) {
      console.error(error);
    }

    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, [paramId]);

  // bind schedule data into local state
  useEffect(() => {
    setIsLoading(true);
    const transactions = scheduleUpdatedData?.transaction;
    if (!Array.isArray(transactions) || !transactions.length) return;

    setScheduleDetailsData(transactions[0]);
    setScheduleInternalTxnList(transactions[0]?.internal_transaction_ids);

    setIsScheduleApproved(scheduleDetailsData?.approved === "Y");
    setIsScheduleRejected(scheduleDetailsData?.rejected === "Y");
    setScheduleDeleted(scheduleDetailsData?.deleted === "Y");
    setIsScheduleConfidential(
      (scheduleDetailsData?.confidential_transaction ?? "N") === "Y",
    );
    if (scheduleDetailsData?.internal_account_approval_status === "pending") {
      setScheduleInternalApproved(false);
    }
    if (scheduleId !== id) {
      return;
    }

    setIsLoading(false);
  }, [scheduleUpdatedData, paramId]);

  // transactions created by this schedule
  useEffect(() => {
    const handleFetch = async () => {
      const data = await dispatch(
        internalTransactionsViewAll({
          page_item_count: pageSize,
          page_no: currentPage,
          txn_id: (scheduleDetailsData?.internal_transaction_ids ?? []) || [],
        }),
      );

      setTransactionData(data);
    };
    if (scheduleInternalTxnList?.length > ZERO) {
      handleFetch();
    }
  }, [scheduleInternalTxnList, currentPage, pageSize]);

  // lock body scroll while a modal is open
  useEffect(() => {
    document.body.style.overflow =
      showOccurrencesModal ||
      showPromptModal ||
      showRejectPrompt ||
      isInternalAccountDetailsOpen
        ? "hidden"
        : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [
    showOccurrencesModal,
    showPromptModal,
    showRejectPrompt,
    isInternalAccountDetailsOpen,
  ]);

  useEffect(() => {
    const el = document.querySelector(".main_div");
    el?.scrollTo({ top: 100, behavior: "smooth" });
  }, []);

  // attach lifecycle / UI status to the fetched schedule
  useEffect(() => {
    const lifecycle =
      scheduledInternalDetailsData?.transaction?.[0]?.lifecycle_status;

    const uiState = addLifeCycleStatus({
      lifecycle_status: lifecycle,
      services: services ?? [],
      cardType: "single",
    });

    setScheduleUpdatedData((prev) => {
      const prevLifecycle = prev?.transaction?.[0]?.lifecycle_status;
      const prevUiStatus = prev?.transaction?.[0]?.statusName;
      const newUiStatus = uiState?.statusName;

      if (
        prev &&
        prevLifecycle === lifecycle &&
        prevUiStatus === newUiStatus &&
        prev?.transaction?.length ===
          scheduledInternalDetailsData?.transaction?.length
      ) {
        return prev;
      }

      return {
        ...scheduledInternalDetailsData,
        transaction: scheduledInternalDetailsData?.transaction.map(
          (account) => ({
            ...account,
            loading: false,
            error: false,
            message: "",
            last_updated_user_id_check: false,
            ...uiState,
          }),
        ),
      };
    });

    if (scheduleUpdatedData) {
      setTimeout(() => {
        setIsLoading(false);
      }, IntervalConfiguration.intervalExtraLarge);
    }
    setScheduleId(scheduledInternalDetailsData?.transaction?.[0]?.txn_id);
  }, [scheduleUpdatedData]);

  // slide direction for tab animation
  useLayoutEffect(() => {
    if (tabIndex !== prevIndex) {
      const direction =
        tabIndex > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(tabIndex);
    }
  }, [tabIndex]);

  /* ------------------------------ tab content ----------------------------- */
  const renderDetailSection = () => {
    if (isloading) {
      return null;
    }
    const transactions = scheduledInternalDetailsData?.transaction;
    if (transactions?.length === ZERO) {
      return (
        <div className="text-text-secondary text-font-sm p-padding-md">
          No transaction data available.
        </div>
      );
    }

    switch (tabIndex) {
      case ZERO:
        return (
          <TransferDetailsTab
            transactions={transactions ?? []}
            data={scheduleDetailsData}
            tabIndex={tabIndex}
            animationClass={animationClass}
            isPopup={isPopup}
            hasOccurrenceService={hasOccurrenceService}
            onOccurrencesClick={handleOccurrencesClick}
          />
        );

      case ONE:
        return (
          <AdditionalDetailsTab
            transactions={transactions ?? []}
            tabIndex={tabIndex}
            animationClass={animationClass}
            onImageClick={handleImageClick}
          />
        );

      case TWO:
        return (
          <TransactionsCreatedTab
            tabIndex={tabIndex}
            animationClass={animationClass}
            transactions={transactionData?.payload?.transactions}
            filterRef={scrollContainerRef}
          />
        );

      case THREE:
        return (
          <LabelsTab
            tabIndex={tabIndex}
            animationClass={animationClass}
            labelDetails={labelDetails}
            iconIsDisabled={labelsEditDisabled}
            onEdit={handleEditLabels}
            isPopup={isPopup}
            actionRestricted={actionRestricted}
            setLabelName={setLabelName}
            setOpenLabelSearchPopup={setOpenLabelSearchPopup}
          />
        );

      default:
        return null;
    }
  };

  /* ------------------------ shared timeline status bar -------------------- */
  const statusBarCommonProps = {
    overrideAutoLoader: true,
    whichBtnClicked: btnClicked?.[scheduleId] || "none",
    failedToTakeaction: scheduleApproveFailed || scheduledInternalRejectError,
    failedToTakeactionReason:
      scheduleApproveFailedMessage ||
      scheduledInternalRejectError?.errors?.base?.[0]?.errors?.[0] ||
      scheduleUpdatedData?.message,
    accountApprovalPending: !scheduleInternalApproved && !isScheduleRejected,
    accountApprovalPendingSubHeader: services?.includes("IAScheduledTxn")
      ? "Account is not approved, approve account before approving transaction."
      : "To approve the account, please contact the authorized person.",
    handleApprovalPendingBtn: handleApprovalPendingClick,
    isApprovalPendingDisabled: !services?.includes("IAAccount"),
    rejected: isScheduleRejected,
    rejectedReason: scheduleDetailsData?.rejection_reason,
    pending: !isScheduleApproved && !scheduleDeleted && !isScheduleRejected,
    rejectBtnText: (
      <>
        Reject <br /> Schedule
      </>
    ),
    approveBtnText: (
      <>
        Approve <br /> Schedule
      </>
    ),
  };

  const historyContentBase = {
    txnHistorytype: "Schedule_Internal_Txn",
    destination_account_number:
      scheduleDetailsData?.internal_account_bank_acc_no ?? "",
    source_account_number: scheduleDetailsData?.owner_account_bank_acc_no ?? "",
    owner_account_id: scheduleDetailsData?.owner_account_id ?? "",
    internal_account_id: scheduleDetailsData?.internal_account_id ?? "",
  };

  /* --------------------------------- render ------------------------------- */

  return (
    <>
      <>{RestrictedActionPopup}</>

      {showLabelsPopup && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="fixed left-left-base w-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-light-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated schedules."
            closehandleFunction={handleLabelClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnIds}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={(scheduledInternalDetailsData?.transaction || [])
              .filter((t) => labelTxnIds.includes(t.txn_id))
              .map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleLabelClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
          />
        </div>
      )}

      {openLabelSearchPopup && (
        <ScheduleInternalTransactionViewAllPopup
          onClose={() => {
            setOpenLabelSearchPopup(false);
          }}
          headerTitle={`Transactions with the label - ${labelName}`}
          popupProps={{ isscrollRequired: true }}
          contentProps={{
            txnHistorytype: "Schedule_Internal_Txn",
            flow: "labelsSearch",
            labelName: labelName,
            txnId: scheduledInternalDetailsData?.transaction?.[0]?.txn_id,
          }}
        />
      )}

      {showPromptModal && (
        <div className="fixed z-z-index-max flex  items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-light-opacity">
          <SmallPopup
            headerTitle="Confirm discarding this schedule?"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="No future transactions will be generated from this schedule."
            btnOneText="Cancel"
            btnOneHandleFunction={() => setShowPromptModal(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Discard"
            btnTwoHandleFunction={handleScheduleDiscard}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoLoading={scheduledInternalDiscardLoading ?? false}
          />
        </div>
      )}
      {showOccurrencesModal && (
        <ScheduleTxnOccurrencesPopup
          closeCallback={() => setShowOccurrencesModal(false)}
          occurrences={scheduleOccurrenceDates}
        />
      )}
      {showRejectPrompt && (
        <InternalScheduleTxnDeclinePopup
          allTxnData={scheduleUpdatedData?.transaction}
          internalDetail={true}
          handleClose={() => {
            setShowRejectPrompt(false);

            setbtnClicked(() => ({
              [scheduleDetailsData.txn_id]: undefined,
            }));
          }}
          txnId={scheduleDetailsData?.txn_id ?? "N/A"}
          type="internalScheduleDetail"
          toastType="singleSchedule"
          flow={flow}
          removeDataFromStorage={removeDataFromStorage}
          typeMulti="MultiApprovalSelect"
          updateAllTxn={(updatedData) => {
            setScheduleUpdatedData((prev) => ({
              ...prev,
              transaction: updatedData,
            }));
          }}
        />
      )}
      {openImageUrl && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-light-opacity">
          <MediumImagePopup
            image={selectedImage}
            closehandleFunction={() => setOpenImageUrl(false)}
          />
        </div>
      )}
      {opentimelinepopup && (
        <ScheduleTimelinePopup
          logsData={scheduleUpdatedData?.transaction}
          onClose={closeTimelinePopup}
          handleApprovalClick={handleTimelinePopup}
          showApprovalTimeline={showApprovalTimeline}
          openApprovalTimeline={openApprovalTimeline}
          handleApprovalTimeline={handleApprovalTimeline}
          setOpenApprovalTimeline={setOpenApprovalTimeline}
        />
      )}
      {ownerDetailpop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-light-opacity">
          <OwnerAccountDetailsPopUp
            closeBeneAccountDetailModal={() => setOwnerDetailpop(false)}
            Remibursement_owneraccount_id={
              scheduleDetailsData?.owner_account_id ?? ""
            }
            type={"reimburseowner_details"}
          />
        </div>
      )}
      {isInternalAccountDetailsOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-light-opacity">
          <InternalAccountDetailsPopup
            internalAccDetailOpen={isInternalAccountDetailsOpen}
            closeBeneAccountDetailModal={handleInternalAccountDetailsClose}
            bene_account_id={scheduleDetailsData?.internal_account_id ?? ""}
            type="bene_account_detail_modal"
          />
        </div>
      )}

      {openTxnHistory && (
        <HistoryPopup
          title="Schedule history"
          onClose={() => setOpenTxnHistory(false)}
          contentProps={{
            openTxnHistory,
            onClose: () => {
              setOpenTxnHistory(false);
              setIsLoading(true);
              setTimeout(() => {
                setIsLoading(false);
              }, IntervalConfiguration.intervalMedium);
            },
            ...historyContentBase,
          }}
        />
      )}
      {hasTransactionRows && selectedDetail === "Transaction created" && (
        <div className="fixed bottom-bottom-base w-width-full z-z-index-content">
          <PaginationComponent
            handleSelect={handleSelect}
            selectedValue={selectedValue}
            data={transactionData?.payload}
            pageSize={pageSize}
            dropdownOptions={dropdownOptions}
            handlePagination={handlePagination}
            currentPage={currentPage}
            setIsOpen={setIsOpen}
          />
        </div>
      )}
      {openConfHistory && (
        <HistoryPopup
          title="Confidential transaction"
          onClose={() => setOpenConfHistory(false)}
          contentProps={{ ...historyContentBase, isConf: true }}
        />
      )}

      {!isPopup && (
        <div className=" fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-loader bg-primary-nav shadow-box-shadow-bottom Qsmd:hidden block">
          <TopNavComponent
            isFormattingNotRequired={true}
            topNavHeader={"Internal Transaction"}
            topNavSubText="Schedule details"
          />
        </div>
      )}
      {isloading ? (
        <div className="fixed inset-0 flex flex-1   items-center justify-center m-auto">
          <Loader />
        </div>
      ) : (
        <div
          className={`flex flex-col ${isPopup ? "h-full" : "h-screen"} overflow-hidden`}
        >
          <div
            className={`bg-primary-nav ${isPopup ? "hidden" : "h-mobile-create-header Qsmd:h-navbar-breadcrumb-height flex Qsmd:flex-shrink-0"}`}
          ></div>
          <div
            ref={scrollContainerRef}
            className={` scroll-py-top_md bg-primary-bg flex flex-col flex-1  overflow-x-hidden ${
              isPopup || openTxnHistory
                ? "overflow-y-hidden"
                : ` Qlg:overflow-y-auto ${
                    tabIndex === TWO && hasTransactionRows
                      ? "mb-[--pagination-height]"
                      : ""
                  } `
            }`}
          >
            <div
              className={`bg-primary-bg ${isPopup ? "overflow-y-auto overflow-x-hidden" : ""}`}
            >
              <>
                <ScheduleSummaryDesktop
                  data={scheduleDetailsData}
                  isPopup={isPopup}
                  isConfidential={isScheduleConfidential}
                  isDeleted={scheduleDeleted}
                  ownerDisabled={ownerDisabled}
                  internalDisabled={internalDisabled}
                  hasModService={hasModService}
                  onOpenConfidential={runIfNotPopup(openConfidentialHistory)}
                  onOpenHistory={runIfNotPopup(openTransactionHistory)}
                  onOwnerClick={handleOwnerClick}
                  onInternalClick={handleInternalAccountClick}
                  onDiscardClick={runIfNotPopup(handleDiscardClick)}
                />
                <ScheduleSummaryMobile
                  data={scheduleDetailsData}
                  ownerDisabled={ownerDisabled}
                  internalDisabled={internalDisabled}
                  onOwnerClick={handleOwnerClick}
                  onInternalClick={handleInternalAccountClick}
                />
              </>
              <div className="block Qsmd:hidden">
                {showStatusBar && (
                  <TimelineStatusBar
                    {...statusBarCommonProps}
                    showMobile={true}
                    isLoading={scheduledInternalApproveLoading}
                    rejectMobClick={handleRejectClick}
                    isApproveMobDisable={!hasModService}
                    approveMobClick={handleApproveClick}
                    isRejectMobDisable={!hasModService}
                  />
                )}
              </div>
              <div className="flex flex-col justify-center bg-primary-bg">
                <div className="max-w-screen-Qlg lg:w-max-content-width w-width-full mx-auto mt-margin-md">
                  <div className="block Qsmd:hidden">
                    <CommonQuickActionButtons
                      title="Quick Actions"
                      actions={[
                        {
                          key: "schedule-history",
                          btnText: (
                            <>
                              Schedule
                              <br />
                              history
                            </>
                          ),
                          btnType: "button",
                          icon: ICONS?.TRANSACTION_HISTORY,
                          handleFunction: runIfNotPopup(openTransactionHistory),
                          isDisabled: isPopup,
                        },
                        {
                          key: "discard-schedule",
                          hidden: scheduleDeleted,
                          btnText: (
                            <>
                              Discard
                              <br />
                              Schedule
                            </>
                          ),
                          btnType: "button",
                          icon: ICONS?.DISCARD_WITH_WHITE_CIRCLE,
                          handleFunction: runIfNotPopup(handleDiscardClick),
                          isDisabled: isPopup || !hasModService,
                        },
                        {
                          key: "confidential-txn",
                          hidden: !isScheduleConfidential,
                          btnText: (
                            <>
                              Confidential
                              <br />
                              transaction
                            </>
                          ),
                          btnType: "button",
                          icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                          handleFunction: runIfNotPopup(
                            openConfidentialHistory,
                          ),
                          isDisabled: isPopup,
                        },
                      ]}
                    />
                  </div>
                  <div
                    className={`Qlg:mx-margin-base ml-margin-md mr-margin-md mt-margin-md Qlg:mt-margin-base Qlg:mr-margin-base Qsmd:mx-margin-md flex flex-row items-end ${
                      !(
                        isScheduleApproved ||
                        isScheduleRejected ||
                        scheduleDeleted
                      )
                        ? ""
                        : "justify-start"
                    } `}
                  >
                    <div
                      className={`bg-primary-card rounded-t-border-radius-md rounded-bl-border-radius-md  ${isScheduleApproved || scheduleDeleted ? "rounded-br-border-radius-md" : "rounded-br-border-radius-md Qsmd:rounded-br-none"} w-width-full Qsmd:w-width-sm Qlg:w-width-sm`}
                    >
                      <div
                        className={`bg-primary-nav relative rounded-border-radius-md w-width-full ${isPopup ? "cursor-not-allowed" : " "}`}
                      >
                        <div className="text-text-primary text-font-xs text-left font-semibold pt-padding-sm mb-margin-sm px-padding-md">
                          Schedule timeline
                        </div>
                        <hr className="relative left-left-base border-primary-bg border-t-border mx-margin-md"></hr>

                        <div>
                          <CommonTimeLineCard
                            logsData={scheduleUpdatedData.transaction}
                            approvalStatus={false}
                            handleApprovalClick={handleTimelinePopup}
                            showApprovalTimeline={true}
                            showDistributionTimeline={false}
                            showDistributionRightIcon={true}
                            isDisabled={isPopup ? true : false}
                            showApprovalLeftIcon={true}
                            showApprovalDuration={true}
                            cardType={"single"}
                            leftCardTitle="Stage - Approval"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Web */}
                    {showStatusBar && (
                      <TimelineStatusBar
                        {...statusBarCommonProps}
                        showMobile={false}
                        hasDistributionData={false}
                        rejectClick={handleRejectClick}
                        isRejectDisable={!hasModService}
                        approveClick={handleApproveClick}
                        isApproveDisable={!hasModService}
                      />
                    )}
                  </div>
                </div>
                <div
                  className={`bg-primary-bg Qlg:px-padding-md lg:px-padding-base mx-margin-md Qlg:mx-margin-base ${scheduleDetailsData?.payload?.transactions?.length > ZERO ? "w-width-full" : ""}`}
                >
                  <div className="mt-margin-md flex max-w-screen-Qlg mx-auto">
                    <div
                      className="flex gap-gap-sm bg-primary-card w-auto rounded-border-radius-md overflow-x-auto"
                      style={{ scrollbarWidth: "none" }}
                    >
                      <SwitcherTabs
                        initialActiveTab={
                          selectedDetail in TAB_INDEX_BY_LABEL
                            ? selectedDetail
                            : "Details"
                        }
                        tabs={[
                          {
                            label: "Details",
                            key: "Details",
                            handler: selectTab("Details", ZERO),
                          },
                          {
                            label: "Category specific details",
                            key: "Additional details",
                            handler: selectTab("Additional details", ONE),
                          },
                          ...(hasCreatedTransactions
                            ? [
                                {
                                  label: "Transaction created",
                                  key: "Transaction created",
                                  handler: selectTab(
                                    "Transaction created",
                                    TWO,
                                  ),
                                },
                              ]
                            : []),
                          {
                            label: "Labels",
                            key: "Assigned Labels",
                            handler: selectTab("Assigned Labels", THREE),
                          },
                        ]}
                        setTabIndex={setTabIndex}
                      />
                    </div>
                  </div>
                  <div className="sched-detail-pane">
                    {renderDetailSection()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ScheduleInternalTransactionDetails;
